export const QUERY__REFERRALS = 'referrals';
export const QUERY__REFERRAL_PROGRESS = 'referralProgress';
